import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const HabitKeyRequestDetailHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Massage Center Detail</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default HabitKeyRequestDetailHeader;
